import StreamSlider from './StreamSlider';
// StreamSliderGrid used to be used for news on the landing page
import StreamSliderGrid from './StreamSliderGrid';

export { StreamSlider, StreamSliderGrid };



// WEBPACK FOOTER //
// ./src/components/StreamSlider/index.js